// RiskPill.jsx
import React from "react";
import { riskClass } from "../utils/format";

export default function RiskPill({ level }) {
  if (!level) return null;
  return <span className={riskClass(level)} data-testid={`risk-pill-${(level || '').toLowerCase()}`}>{level}</span>;
}
